import { render, staticRenderFns } from "./PuntosEntregaYRemisiones.vue?vue&type=template&id=2458fc1a&scoped=true"
import script from "./PuntosEntregaYRemisiones.vue?vue&type=script&lang=js"
export * from "./PuntosEntregaYRemisiones.vue?vue&type=script&lang=js"
import style0 from "./PuntosEntregaYRemisiones.vue?vue&type=style&index=0&id=2458fc1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2458fc1a",
  null
  
)

export default component.exports